import { ImportExternalErpServicesFlow } from '@Components/Stammdaten';
import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables/TableWithStoredSettingsAndLayoutSettings';
import { STAMMDATEN_API } from '@Constants/backendConstants';
import { Permission } from '@Constants/Permission.g';
import { serviceColumns } from '@Constants/TableColumns';
import { useHasPermission } from '@Contexts/appContext';
import { useExternalErpImport } from '@Hooks/Stammdaten/useExternalErpImport';
import type { ApiService } from '@Model';
import { EnumFrontendLayoutSetting } from '@Model';
import { useListApi } from '@Hooks/useListApi';
import { ServicesRepository } from '@Repositories/Stammdaten';

export function FrameListService() {
    const hasPermission = useHasPermission();

    const module = useListApi(ServicesRepository, STAMMDATEN_API);

    const { toolbarElements, flowProps, tableKey } = useExternalErpImport('Leistungen importieren');

    return (
        <>
            <TableWithStoredSettingsAndLayoutSettings<ApiService>
                layoutSettingsContext={EnumFrontendLayoutSetting.ServicesTableLayout}
                name="ServiceList"
                columns={serviceColumns}
                loader={module.loadPage}
                canCreate={hasPermission(Permission.StammdatenServiceCreate)}
                key={tableKey}
                useOnClickNavigation
                fullSize
                toolbarElements={toolbarElements}
            />
            <ImportExternalErpServicesFlow {...flowProps} />
        </>
    );
}
